import React from 'react';
import { Select, Input, Typography } from 'antd';
import stc from 'string-to-color';

const CSAFilterModalContent = ({
    companyCode,
    onChangeCompanyCode,
    companyCodeList,
    barcode,
    onChangeBarcode,
    filters = {},
    filterList = [],
    onChangeFilters,
}) => {
    const handleFilterChange = (key, values) => {
        const next = {
            ...(filters || {}),
            [key]: values,
        };
        if (onChangeFilters) {
            onChangeFilters(next);
        }
    };

    const normalizedFilters = Array.isArray(filterList)
        ? filterList
              .map((f) => {
                  const values = Array.isArray(f.values)
                      ? f.values.map((v) =>
                            v && typeof v === 'object' && 'label' in v && 'value' in v
                                ? v
                                : {
                                      label: String(v),
                                      value: v,
                                  },
                        )
                      : [];
                  return {
                      title: f.title || f.key,
                      key: f.key,
                      path: f.path ?? null,
                      values: [{ label: 'N/A', value: null }, ...values],
                  };
              })
              .sort((a, b) =>
                  String(a.title ?? '').localeCompare(String(b.title ?? ''), undefined, { sensitivity: 'base' })
              )
        : [];

    const filterGroups = normalizedFilters.reduce((acc, f) => {
        const first = String(f.title ?? '').trim().charAt(0).toUpperCase();
        const letter = /[A-Z]/.test(first) ? first : '#';
        const bucket = acc.find((g) => g.letter === letter);
        if (bucket) {
            bucket.items.push(f);
        } else {
            acc.push({ letter, items: [f] });
        }
        return acc;
    }, []);

    const availableLetters = new Set(filterGroups.map((g) => g.letter));
    const ALL_LETTERS = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ', '#'];

    const scrollToLetter = (letter) => {
        const el = document.getElementById(`csa-filter-group-${letter}`);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <div className="csa-list-filters csa-list-filters-modal csa-filter-modal-layout">
            <div className="csa-filter-modal-content">
            {filterGroups.length > 0 &&
                filterGroups.map((group) => (
                    <div
                        id={`csa-filter-group-${group.letter}`}
                        key={group.letter}
                        className="csa-list-dynamic-filter-group"
                    >
                        <div className="csa-list-dynamic-filter-group-letter">
                            {group.letter}
                        </div>
                        <div className="csa-list-dynamic-filters">
                            {group.items.map((filter) => (
                                <div
                                    key={filter.key}
                                    className="csa-list-dynamic-filter"
                                >
                                    <Typography.Text className="csa-list-dynamic-filter-label">
                                        {filter.title}
                                        {filter.path ? (
                                            <Typography.Text
                                                type="secondary"
                                                style={{ fontWeight: 'normal', fontSize: '0.85em' }}
                                            >
                                                {' '}
                                                ({filter.path})
                                            </Typography.Text>
                                        ) : null}
                                    </Typography.Text>
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        maxTagCount="responsive"
                                        placeholder={`Select ${filter.title}`}
                                        className="csa-list-dynamic-filter-select"
                                        value={filters?.[filter.key]}
                                        onChange={(vals) =>
                                            handleFilterChange(filter.key, vals)
                                        }
                                        options={filter.values}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className="csa-filter-modal-alphabet">
                {ALL_LETTERS.map((letter) => {
                    const enabled = availableLetters.has(letter);
                    return (
                        <button
                            key={letter}
                            type="button"
                            className={`csa-filter-modal-alphabet-letter${enabled ? '' : ' is-disabled'}`}
                            onClick={enabled ? () => scrollToLetter(letter) : undefined}
                            disabled={!enabled}
                        >
                            {letter}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default CSAFilterModalContent;

